<template>
    <div class="SpinnerGlobal SpinnerGlobal--relative is-active">
        <div class="SpinnerGlobal-spinner"></div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "SpinnerGlobal",
});
</script>

<style lang="scss" scoped>
.SpinnerGlobal {
    $block: &;

    &--relative {
        position: relative;
        background: transparent;
        min-height: 50px;

        #{$block}-spinner {
            width: 15px;
            height: 15px;
        }

        &.is-active #{$block}-spinner {
            &::before, &::after {
                width: 15px;
                height: 15px;
            }

            &::before {
                margin-left: 15px;
            }

            &::after {
                margin-top: -15px;
                margin-left: -15px;
            }
        }
    }
}

</style>